import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CommentInput = ({
  onSend,
}: {
  onSend: (message: string) => void;
}) => {
  const [message, setMessage] = useState('');
  const { t } = useTranslation('project', { keyPrefix: 'Comments' });

  return (
    <div className="flex w-full items-center gap-[12px]">
      <div className="flex h-[36px] flex-1 items-center gap-[8px] overflow-clip rounded-[8px] border-[0.5px] border-[rgba(255,255,255,0.32)] bg-[rgba(255,255,255,0.05)] p-[8px] shadow-[inset_0px_20px_50px_0px_rgba(255,255,255,0.01)]">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={t('placeholder')}
          className="w-full bg-transparent text-[13px] font-normal leading-[18px] tracking-[-0.4px] text-[#d9d9d9] placeholder:text-[#d9d9d9] focus:outline-none"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onSend(message);
              setMessage('');
            }
          }}
        />
      </div>
      <button
        type="button"
        onClick={() => {
          onSend(message);
          setMessage('');
        }}
        className="flex h-[36px] w-[86px] items-center justify-center rounded-[8px] border-[0.5px] border-solid border-white px-[16px] py-[10px] text-[13px] font-[510] tracking-[-0.4px] text-black transition-opacity hover:opacity-90"
        style={{
          backgroundImage:
            'linear-gradient(97.9798deg, rgb(161, 255, 128) 0.16086%, rgb(113, 178, 90) 147.39%)',
        }}
      >
        {t('send')}
      </button>
    </div>
  );
};
